import styled, { css } from "react-emotion/macro"
import { mq } from "../styles/variables"

export const Container = styled("div")`
  max-width: 1170px;
  margin: 0 auto;
  padding-left: 15px;
  padding-right: 15px;

  ${mq.md(css`
    padding-left: 25px;
    padding-right: 25px;
  `)};
`



// WEBPACK FOOTER //
// /opt/build/repo/src/components/StyledComponents.js